import React from 'react';
import { DollarSign, TrendingUp, AlertCircle, RefreshCcw } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { mockTransactions, formatNaira } from '../../data/mockData';
const revenueData = [{
  name: 'Jan',
  rev: 12
}, {
  name: 'Feb',
  rev: 19
}, {
  name: 'Mar',
  rev: 15
}, {
  name: 'Apr',
  rev: 22
}, {
  name: 'May',
  rev: 28
}, {
  name: 'Jun',
  rev: 25
}, {
  name: 'Jul',
  rev: 35
}, {
  name: 'Aug',
  rev: 32
}, {
  name: 'Sep',
  rev: 42
}];
export const Finance = () => {
  return <div className="space-y-6 animate-in fade-in" data-id="element-593">
      <div data-id="element-594">
        <h1 className="text-2xl font-serif font-bold text-slate-900 dark:text-white mb-1" data-id="element-595">
          Finance & Payments
        </h1>
        <p className="text-slate-500 dark:text-slate-400" data-id="element-596">
          Revenue tracking and transaction history.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-597">
        {[{
        label: 'Total Revenue',
        value: '₦425M',
        icon: DollarSign,
        color: 'text-emerald-600 dark:text-emerald-400',
        bg: 'bg-emerald-100 dark:bg-emerald-400/10'
      }, {
        label: 'Monthly Revenue',
        value: '₦42.5M',
        icon: TrendingUp,
        color: 'text-blue-600 dark:text-blue-400',
        bg: 'bg-blue-100 dark:bg-blue-400/10'
      }, {
        label: 'Failed Transactions',
        value: '12',
        icon: AlertCircle,
        color: 'text-red-600 dark:text-red-400',
        bg: 'bg-red-100 dark:bg-red-400/10'
      }, {
        label: 'Refund Requests',
        value: '3',
        icon: RefreshCcw,
        color: 'text-orange-600 dark:text-orange-400',
        bg: 'bg-orange-100 dark:bg-orange-400/10'
      }].map((stat, i) => {
        const Icon = stat.icon;
        return <div key={i} className="bg-white dark:bg-[#1e293b] p-5 rounded-2xl border border-slate-200 dark:border-slate-700 flex items-center gap-4" data-id="element-598">
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${stat.bg} ${stat.color}`} data-id="element-599">
                <Icon size={24} data-id="element-600" />
              </div>
              <div data-id="element-601">
                <div className="text-2xl font-bold text-slate-900 dark:text-white" data-id="element-602">
                  {stat.value}
                </div>
                <div className="text-xs font-bold text-slate-500 dark:text-slate-400 uppercase tracking-wider" data-id="element-603">
                  {stat.label}
                </div>
              </div>
            </div>;
      })}
      </div>

      <div className="grid lg:grid-cols-3 gap-6" data-id="element-604">
        <div className="lg:col-span-2 bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-6" data-id="element-605">
          <h3 className="font-bold text-slate-900 dark:text-white mb-6" data-id="element-606">
            Revenue Trend (Millions ₦)
          </h3>
          <div className="h-64" data-id="element-607">
            <ResponsiveContainer width="100%" height="100%" data-id="element-608">
              <LineChart data={revenueData} data-id="element-609">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="currentColor" className="text-slate-200 dark:text-slate-700" data-id="element-610" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fill: '#94a3b8',
                fontSize: 12
              }} data-id="element-611" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#94a3b8',
                fontSize: 12
              }} data-id="element-612" />
                <Tooltip contentStyle={{
                backgroundColor: 'var(--tw-bg-opacity, #fff)',
                borderColor: 'var(--tw-border-opacity, #e2e8f0)',
                color: 'var(--tw-text-opacity, #0f172a)'
              }} itemStyle={{
                color: 'var(--tw-text-opacity, #0f172a)'
              }} data-id="element-613" />
                <Line type="monotone" dataKey="rev" stroke="#C8A24A" strokeWidth={3} dot={{
                r: 4,
                fill: '#C8A24A',
                strokeWidth: 2,
                stroke: 'currentColor'
              }} className="text-white dark:text-[#1e293b]" data-id="element-614" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 overflow-hidden flex flex-col" data-id="element-615">
          <div className="p-4 border-b border-slate-200 dark:border-slate-700" data-id="element-616">
            <h3 className="font-bold text-slate-900 dark:text-white" data-id="element-617">
              Recent Transactions
            </h3>
          </div>
          <div className="flex-grow overflow-y-auto custom-scrollbar p-2" data-id="element-618">
            {mockTransactions.map(txn => <div key={txn.id} className="p-3 border-b border-slate-100 dark:border-slate-700/50 last:border-0 flex justify-between items-center" data-id="element-619">
                <div data-id="element-620">
                  <div className="font-bold text-sm text-slate-900 dark:text-slate-200" data-id="element-621">
                    {txn.id}
                  </div>
                  <div className="text-xs text-slate-500 dark:text-slate-400" data-id="element-622">
                    {txn.user}
                  </div>
                </div>
                <div className="text-right" data-id="element-623">
                  <div className="font-bold text-sm text-slate-900 dark:text-white" data-id="element-624">
                    {formatNaira(txn.amount)}
                  </div>
                  <div className={`text-[10px] font-bold uppercase ${txn.status === 'Success' ? 'text-emerald-600 dark:text-emerald-400' : 'text-red-600 dark:text-red-400'}`} data-id="element-625">
                    {txn.status}
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};